export const passwordResetMailSent = {
  title: 'Passwort zurücksetzen',
  text: 'Sie erhalten in Kürze eine Email mit einem Link zum zurücksetzen Ihres Passwortes an folgende E-Mail-Adresse:',
  text2: 'Sollte diese E-Mail nicht korrekt sein, führen Sie den Vorgang bitte erneut aus.',
  forgotPasswordLink: 'Passwort vergessen',
}
